import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=5a1c686a"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"
import style0 from "./gallery.vue?vue&type=style&index=0&id=5a1c686a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports